module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAASdJREFUSEvF1jsOwjAMBuDfOQATJ+Aq3IW1ndoOSBSJIekEK3eDC8DEARoUBFXpI3ZKVBi6EOWTndgxGWPW1tozgAWAQ1EUJ0T8aa0TAFsADyLakNb6AmD1MYiozPN8H8M0xuystWVrr6sDbwCWbSAGOoA54k5VVSV1XR+7Ef2CjmCOSMl9xxZMQbm9XmAslMOc04C/ohKsB05FpdggGIqGYKOgFA3FvCCHuv87Rf26fNzN/ro0Q93FU1O95RzGRsiVzJTuxEYoQSWRNb1a2qR9qY0OSs5RirIplWBNugRPmxf01Vn0spAUtWRN79kLqb2hcwpFeykN3YDrSN1x5X/P05TIusch2WP+EWPOIUoplc4/Js4+CLdHfaXUIcuyqKP++8iaUf8JeZJs7DHuV2cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./statics/imgs/cc.png
// module id = 128
// module chunks = 0